import styled from '@emotion/styled';
import { Checkbox } from 'antd';
import { colors } from '../../../constants';

export default styled(Checkbox)`
  & .ant-checkbox-inner {
    border-width: ${({ borderWidth }) => borderWidth || null} !important;
    width: ${({ width }) => width || '14px'};
    height: ${({ height }) => height || '14px'};
    margin-right: ${({ marginRight }) => marginRight || null};
  }

  & .ant-checkbox-inner::after {
    left: ${({ left }) => left || '3px'};
    top: ${({ top }) => top || 0};
    width: ${({ table }) => (table ? '6px' : '4px')};
    height: ${({ table }) => (table ? '9px' : '8px')};
  }
  
  &>.ant-checkbox-indeterminate:not(.ant-checkbox-checked)>.ant-checkbox-inner::after {
    background-color: ${colors.blueDark};
    left: 6px;
    top: 6px;
    width: 9px;
    height: 9px;
  }
`;
